import React, { useState, useEffect } from 'react';
import { usePackagingOperationsContext } from '../context/PackagingOperationsContext';

const TemperaturesHumidity: React.FC = () => {
    const fields = [
        { id: "pkglinetemp", label: "Packaging Line Temp (°C)" },
        { id: "pkglinehumidity", label: "Packaging Line Humidity (%)" },
        { id: "coolingtunneltemp", label: "Cooling Tunnel Temp (°C)" },
        { id: "creamroomtemp", label: "Cream Room Temp (°C)" },
        { id: "coldstorage1temp", label: "Cold Storage 1 Temp (°C)" },
        { id: "coldstorage2temp", label: "Cold Storage 2 Temp (°C)" },
        { id: "flavourroomtemp", label: "Flavour Room Temp (°C)" },
        { id: "dhroomhumidity", label: "DH Room Humidity (%)" },
        { id: "coldroom1temp", label: "Cold Room 1 Temp (°C)" },
        { id: "coldroom2temp", label: "Cold Room 2 Temp (°C)" },
        { id: "coldroom3temp", label: "Cold Room 3 Temp (°C)" },
        { id: "deepfreezeryeasttemp", label: "Deep Freezer for Yeast (°C)" }
    ];

    const [values, setValues] = useState<Record<string, string>>({});

    const handleChange = (id: string, val: string) => {
        setValues(prev => ({ ...prev, [id]: val }));
    };

    const { dispatch } = usePackagingOperationsContext();

    useEffect(() => {
        dispatch({
            type: 'SET_CHECKLIST_DATA',
            payload: { values }
        });
    }, [values, dispatch]);

    return (
        <div className="p-4 space-y-6">
            <h3 className="text-lg font-bold text-gray-800 border-b pb-2">Temperatures & Humidity Entry</h3>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                {fields.map(f => (
                    <div key={f.id}>
                        <label className="block text-sm font-medium text-gray-700">{f.label}</label>
                        <input 
                            type="text" 
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-2 border" 
                            placeholder="e.g. 24.5 or NA"
                            value={values[f.id] || ''}
                            onChange={e => handleChange(f.id, e.target.value)}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TemperaturesHumidity;
